export interface RsChartColors {
  green: string;
  offWhite: string;
  lightGray: string;
  black: string;
  offBlack: string;
  jet: string;
  jetLight: string;
  salmon: string;
}

const COLOR_TOKENS: Record<keyof RsChartColors, { cssVariable: string; fallback: string }> = {
  green: { cssVariable: "--color-rs-green", fallback: "#80ed40" },
  offWhite: { cssVariable: "--color-rs-off-white", fallback: "#e9ede6" },
  lightGray: { cssVariable: "--color-rs-light-gray", fallback: "#d1d6cc" },
  black: { cssVariable: "--color-rs-black", fallback: "#121410" },
  offBlack: { cssVariable: "--color-rs-off-black", fallback: "#1a1d17" },
  jet: { cssVariable: "--color-rs-jet", fallback: "#363b33" },
  jetLight: { cssVariable: "--color-rs-jet-light", fallback: "#566151" },
  salmon: { cssVariable: "--color-rs-salmon", fallback: "#f58ab5" },
};

export function readRsChartColors(): RsChartColors {
  const rootStyles = typeof document === "undefined" ? null : getComputedStyle(document.documentElement);
  const colorEntries = Object.entries(COLOR_TOKENS).map(([colorName, { cssVariable, fallback }]) => [
    colorName,
    rootStyles?.getPropertyValue(cssVariable).trim() || fallback,
  ]);
  return Object.fromEntries(colorEntries) as RsChartColors;
}
